import type { ReactElement } from 'react';
import { StudioBox, warnUnsupportedNode, type StudioNodeRendererProps } from './box';

/**
 * Rule: a plain hairline — the one decoration primitive that needs no
 * design-token payload beyond what's already in scope (`--doc-border`,
 * defined per family/theme, see `styles/momentum-v2.css`).
 */
export function RuleNode({ node }: StudioNodeRendererProps): ReactElement {
  return <StudioBox node={node} className="tpl-studio-rule" />;
}

// ---------------------------------------------------------------------------
// GradientField / Shape / Linework / BackgroundTexture reference the
// resolved `DesignTokens.colors.gradients` palette (a server-only value —
// `DeckDesignDirection` persists `DesignDNA` + pacing, not the full token
// set), so the client has no gradient/shape spec to render yet. Stubbed
// pending that payload rather than inventing a palette.
// ---------------------------------------------------------------------------

export function GradientFieldNode(props: StudioNodeRendererProps): null {
  warnUnsupportedNode(props.node);
  return null;
}

export function ShapeNode(props: StudioNodeRendererProps): null {
  warnUnsupportedNode(props.node);
  return null;
}

export function LineworkNode(props: StudioNodeRendererProps): null {
  warnUnsupportedNode(props.node);
  return null;
}

export function BackgroundTextureNode(props: StudioNodeRendererProps): null {
  warnUnsupportedNode(props.node);
  return null;
}
